import { createAction } from 'redux-actions';

export const GetDetailCompanyRequested = createAction('GET_DETAIL_COMPANY_REQUESTED');
export const GetDetailCompanyReceived = createAction('GET_DETAIL_COMPANY_RECEIVED');
export const GetDetailCompanyReceiveFailure = createAction('GET_DETAIL_COMPANY_RECEIVE_FAILURE');
export const ClearGetDetailCompany = createAction('CLEAR_GET_DETAIL_COMPANY');

export const EditCompanyRequested = createAction('EDIT_COMPANY_REQUESTED');
export const EditCompanyReceived = createAction('EDIT_COMPANY_RECEIVED');
export const EditCompanyReceiveFailure = createAction('EDIT_COMPANY_RECEIVE_FAILURE');
export const ClearEditCompany = createAction('CLEAR_EDIT_COMPANY');

export const DeleteCompanyRequested = createAction('DELETE_COMPANY_REQUESTED');
export const DeleteCompanyReceived = createAction('DELETE_COMPANY_RECEIVED');
export const DeleteCompanyReceiveFailure = createAction('DELETE_COMPANY_RECEIVE_FAILURE');
export const ClearDeleteCompany = createAction('CLEAR_DELETE_COMPANY');

export const GetListSeminarRequested = createAction('GET_LIST_SEMINAR_ADMIN_REQUESTED');
export const GetListSeminarReceived = createAction('GET_LIST_SEMINAR_ADMIN_RECEIVED');
export const GetListSeminarReceivedFailure = createAction('GET_LIST_SEMINAR_ADMIN_RECEIVED_FAILURE');
export const ClearListSeminar = createAction('CLEAR_LIST_SEMINAR_ADMIN');

export const UpdateSeminarRequested = createAction('UPDATE_SEMINAR_ADMIN_REQUESTED');
export const UpdateSeminarReceived = createAction('UPDATE_SEMINAR_ADMIN_RECEIVED');
export const UpdateSeminarReceivedFailure = createAction('UPDATE_SEMINAR_ADMIN_RECEIVED_FAILURE');
export const ClearSeminar = createAction('CLEAR_ADMIN_SEMINAR');
export const UpdateSeminarProgess = createAction('UPDATE_SEMINAR_ADMIN_PROGESS');

export const GetDetailSeminarRequested = createAction('GET_DETAIL_SEMINAR_ADMIN_REQUESTED');
export const GetDetailSeminarReceived = createAction('GET_DETAIL_SEMINAR_ADMIN_RECEIVED');
export const GetDetailSeminarReceivedFailure = createAction('GET_DETAIL_SEMINAR_ADMIN_RECEIVED_FAILURE');
export const ClearDetailSeminar = createAction('CLEAR_GET_DETAIL_ADMIN_SEMINAR');

export const GetListProductExhibitionRequested = createAction('GET_LIST_PRODUCT_EXHIBITION_REQUESTED');
export const GetListProductExhibitionReceived = createAction('GET_LIST_PRODUCT_EXHIBITION_RECEIVED');
export const GetListProductExhibitionReceiveFailure = createAction('GET_LIST_PRODUCT_EXHIBITION_RECEIVE_FAILURE');
export const ClearGetListProductExhibition = createAction('CLEAR_GET_LIST_PRODUCT_EXHIBITION');

export const GetDetailProductExhibitionRequested = createAction('GET_DETAIL_PRODUCT_EXHIBITION_REQUESTED');
export const GetDetailProductExhibitionReceived = createAction('GET_DETAIL_PRODUCT_EXHIBITION_RECEIVED');
export const GetDetailProductExhibitionReceiveFailure = createAction('GET_DETAIL_PRODUCT_EXHIBITION_RECEIVE_FAILURE');
export const ClearGetDetailProductExhibition = createAction('CLEAR_GET_DETAIL_PRODUCT_EXHIBITION');

export const EditProductExhibitionRequested = createAction('EDIT_PRODUCT_EXHIBITION_REQUESTED');
export const EditProductExhibitionReceived = createAction('EDIT_PRODUCT_EXHIBITION_RECEIVED');
export const EditProductExhibitionReceiveFailure = createAction('EDIT_PRODUCT_EXHIBITION_RECEIVE_FAILURE');
export const ClearEditProductExhibition = createAction('CLEAR_EDIT_PRODUCT_EXHIBITION');

export const DeleteProductExhibitionRequested = createAction('DELETE_PRODUCT_EXHIBITION_REQUESTED');
export const DeleteProductExhibitionReceived = createAction('DELETE_PRODUCT_EXHIBITION_RECEIVED');
export const DeleteProductExhibitionReceiveFailure = createAction('DELETE_PRODUCT_EXHIBITION_RECEIVE_FAILURE');
export const ClearDeleteProductExhibition = createAction('CLEAR_DELETE_PRODUCT_EXHIBITION');

export const callApiDeleteSeminarOfCompany = createAction('CALL_API_DELETE_SEMINAR_OF_COMPANY');
export const callApiDeleteSeminarOfCompanyReceived = createAction('CALL_API_DELETE_SEMINAR_OF_COMPANY_RECEIVED');
export const callApiDeleteSeminarOfCompanyReceivedFailure = createAction('CALL_API_DELETE_SEMINAR_OF_COMPANY_RECEIVED_FAILURE');
export const clearCallApiDeleteSeminarOfCompany = createAction('CLEARE_CALL_API_DELETE_SEMINAR_OF_COMPANY');

export const GetDetailCompanyForSidebarRequested = createAction('GET_DETAIL_COMPANY_FOR_SIDEBAR_REQUESTED');
export const GetDetailCompanyForSidebarReceived = createAction('GET_DETAIL_COMPANY_FOR_SIDEBAR_RECEIVED');
export const GetDetailCompanyForSidebarReceiveFailure = createAction('GET_DETAIL_COMPANY_FOR_SIDEBAR_RECEIVE_FAILURE');
export const ClearGetDetailCompanyForSidebar = createAction('CLEAR_GET_DETAIL_COMPANY_FOR_SIDEBAR');
